import * as actions from './actions';
import {
    GET_ASSETS_TO_VAULTS,
    GET_USER_VAULTS,
    SET_USER_VAULTS,
    SET_USER_MARGIN_ACCOUNTS,
    GET_MARGIN_ACCOUNTS,
} from './constants';

import { Token } from '@/shared/api/borrow';
import { MarginAccount } from '@/shared/api/vault';

export type UserVault = {
    balance?: string;
    apy?: string;
    curator?: string;
    reward?: string;
    address?: string;
    title?: string;
    totalDeposited?: string;
    totalDepositThreshold?: string;
    tokenAddress?: string;
    tokenSymbol?: string;
    tokenDecimals?: number;
    netApy?: string;
};

export type UserVaultState = {
    userVaultsLoading: boolean;
    userVaults: UserVault[];
    assetsToVaultsLoading: boolean;
    assetsToVaults: Token[];
    hasUserVaults: boolean;
};

type State = UserVaultState & MarginAccountState;

const defaultState: State = {
    userVaultsLoading: false,
    userVaults: [],
    assetsToVaultsLoading: false,
    assetsToVaults: [],
    hasUserVaults: false,
    marginAccountsLoading: false,
    marginAccounts: [],
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function userVaults(state = defaultState, action: OrderAction): State {
    switch (action.type) {
        case GET_USER_VAULTS:
        case SET_USER_VAULTS:
        case GET_ASSETS_TO_VAULTS:
            return {
                ...state,
                ...userVaultsReducer(state, action),
            };
        case GET_MARGIN_ACCOUNTS:
        case SET_USER_MARGIN_ACCOUNTS:
            return {
                ...state,
                ...marginAccountsReducer(state, action),
            };
        default: {
            return state;
        }
    }
}

function userVaultsReducer(state: UserVaultState, action: OrderAction): Partial<UserVaultState> {
    switch (action.type) {
        case GET_USER_VAULTS:
        case GET_ASSETS_TO_VAULTS:
            return {
                ...state,
                userVaultsLoading: true,
            };
        case SET_USER_VAULTS:
            return {
                ...state,
                userVaultsLoading: false,
                userVaults: action.payload,
                hasUserVaults: action.payload.length > 0,
            };
        default:
            return {};
    }
}

type MarginAccountState = {
    marginAccountsLoading: boolean;
    marginAccounts: MarginAccount[];
};

function marginAccountsReducer(
    state: UserVaultState,
    action: OrderAction,
): Partial<MarginAccountState> {
    switch (action.type) {
        case GET_MARGIN_ACCOUNTS:
            return {
                ...state,
                marginAccountsLoading: true,
            };
        case SET_USER_MARGIN_ACCOUNTS:
            return {
                ...state,
                marginAccountsLoading: false,
                marginAccounts: action.payload,
            };
        default:
            return {};
    }
}
